import { __spreadValues } from '../chunk-WE74IZDZ.mjs';
import { InjectedConnector } from 'wagmi/connectors/injected';

function getWindowProviderNamespace(namespace) {
  const providerSearch = (provider2, searchNamespace) => {
    const [property, ...path] = searchNamespace.split(".");
    const _provider = provider2[property];
    if (_provider) {
      if (path.length === 0)
        return _provider;
      return providerSearch(_provider, path.join("."));
    }
    return void 0;
  };
  if (typeof window === "undefined")
    return void 0;
  const provider = providerSearch(window, namespace);
  return provider || void 0;
}
var KasWareConnector = class extends InjectedConnector {
  constructor(config = {}) {
    super({
      chains: config.chains,
      options: __spreadValues({
        name: "KasWare",
        shimDisconnect: true,
        getProvider: () => getWindowProviderNamespace("kasware.ethereum")
      }, config.options)
    });
    this.id = "kasWare";
    this.name = "KasWare";
  }
};

export { KasWareConnector, getWindowProviderNamespace };
